import React, { useCallback, useEffect, useState } from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../Legacy';
import { Icon } from '../../../concepts/resources/Icon';
import { Button, Colors, Spinner, usePrompt } from '../../../ui';
import { useResolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { AccountModel } from '../../account/AccountModel';
import { Copy, Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { PopupManager } from '../../popups/PopupManager';
import { UpgradeButton } from '../../upgrade/UpgradeButton';
import { Atlassian } from './Atlassian';

export const useJiraOAuth = () => {
    const popups = useResolve(PopupManager);

    const me = useObserver(useResolve(ProfileModel));
    const jiraConnected = me.connections.some(x => x.externalSystemType === 'atlassian-oauth');

    const onJiraConnect = useCallback(async () => {
        const { actioned } = await popups.invoke(jiraOAuthRequiredPopup());
        return actioned;
    }, []);

    return { jiraConnected, onJiraConnect };
};

export const jiraOAuthRequiredPopup = () => ({ ui: JiraOAuthRequiredPopup });

export const JiraOAuthRequiredPopup: LFC<PopupProps> = ({ dismiss }) => {

    const [waiting, setWaiting] = useState(false);
    const me = useObserver(useResolve(ProfileModel));
    const account = useResolve(AccountModel);

    useEffect(() => {
        if (me.connections.some(x => x.externalSystemType === 'atlassian-oauth')) {
            dismiss();
        }
    }, [me]);

    const onAction = () => {
        Atlassian.link();
        setWaiting(true);
    };

    const promptRef = usePrompt({
        ignoreEnter: true,
        onAction: dismiss,
    });

    return <Popup ref={promptRef} p="1">
        <Popup.Header>
            <Popup.IconFrame>
                <Icon src="deqo://icons/i8/color-jira" size="2" />
            </Popup.IconFrame>
            <Popup.Title>
                Sign-in to Atlassian
            </Popup.Title>
            <Popup.SubTitle>
                Connect your Ludi account to Atlassian.
            </Popup.SubTitle>
        </Popup.Header>
        <Popup.Content>
            {account.plan.features.jiraBeta &&
                <Flexer width="36" height="16" flex="column" center gap="2">
                    <Button size="xl" variant="primary" onAction={onAction}>
                        Sign-in to Atlassian
                    </Button>
                    {waiting &&
                        <Flexer flex="row" center gap=".5" color={Colors.textLight}>
                            <Title color={Colors.textLight}>Waiting for connection </Title> <Spinner size={1.5} stroke={4} />
                        </Flexer>
                    }
                </Flexer>
            }
            {!account.plan.features.jiraBeta && <Flexer width="36" height="16" flex="column" center gap="2">
                <Copy flush>
                    Sorry, Jira integration is only available on our Business & Enterprise plans.
                </Copy>
                <UpgradeButton />
            </Flexer>}
        </Popup.Content>
        <Popup.Close onAction={dismiss} />
    </Popup>;
};
